import React from "react";
import { motion } from "framer-motion";

function ExpertCard({ title, description }) {
  return (
    <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
      <motion.div
        initial={{ opacity: 0, scale: 0.5}}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, delay: 0.8, type: "spring" }}
        viewport={{ once: true }} 
        className="flex-wrap grow justify-center content-start p-3 w-full font-semibold text-white expert-card rounded-xl shadow-xl max-md:mt-4 max-md:max-w-full">
        <h3 className="mb-0 pb-1 text-lg sm:text-xl leading-5">{title}</h3>
        <span className="text-lg text-white font-thin leading-5">{description}</span>
      </motion.div>
    </div>
  );
}

export default ExpertCard;